/* eslint-disable no-unused-vars */

import React from 'react';

/* eslint-enable no-unused-vars */

const maxMobileWidth = 767;

const settings = {
  title: 'Chessvision.ai',

  routes: {
    HOME: '/',

    BOARD_ANALYSIS: '/analysis',
    READER_BOARD_ANALYSIS: '/reader/analysis',
    BOARD_EDITOR:  '/editor',
    BOARD_POSITION_ONLY_EDITOR:  '/position-only-editor',
    LICHESS_BOARD_ANALYSIS:  '/lichess-analysis',
  },

  values: {
    maxMobileWidth,
    maxContainerWidth: 1024,
    lichessAnalysisBoardUrl: 'https://lichess.org/analysis',
  },
  
  engine: {
    ENGINE_DEFAULT_TYPE: 'classic', // 'classic' or 'nnue'
    ENGINE_NAME: 'Stockfish NNUE',
    ENGINE_NAME_SHORT: 'Stockfish NNUE',
    // This flag controls automatic NNUE -> Classic fallback only.
    // Classic is always available in the selector and uses the URL below.
    ENGINE_JS_FALLBACK_ENABLED: true,
    ENGINE_JS_FALLBACK_URL: '/sf11/stockfish.asm.js',
    ENGINE_JS_FALLBACK_NAME: 'Stockfish',
    ENGINE_JS_FALLBACK_NAME_SHORT: 'Stockfish',
    ENGINE_DEPTH: 23,
    ENGINE_MULTIPV: 2,
    MAX_ENGINE_LINE: 8,
    ARROWS_CENTIPAWNLOSS_THRESH: 100,
    ENGINE_DEFAULT_ON: false,

    REMEMBER_ENGINE_ENABLED_ANALYSIS: false,
    REMEMBER_ENGINE_ENABLED_READER_ANALYSIS: false,
    REMEMBER_ENGINE_SELECTION_ANALYSIS: true,
    REMEMBER_ENGINE_SELECTION_READER_ANALYSIS: true,
  },
};

export default settings;
